import { useView, autoinject, Container } from 'aurelia-framework'
import { PLATFORM } from 'aurelia-pal';

@useView(PLATFORM.moduleName("./RedirectSuccessView.html"))
export default class RedirectSuccessVM {
}
